// Fill-in fields in prompt templates: "Create [X] posts about [theme]".
// Mirrors Content::Placeholder (app/models/content/placeholder.rb).
export const PATTERN = /\[([^[\]\n]{1,40})\](?!\()/g

export function isField(text: string): boolean {
  if (text.includes(':')) return false
  return text.length === 1 || text !== text.toUpperCase()
}

export function fields(template: string): string[] {
  const names = [...template.matchAll(PATTERN)].map((m) => m[1]).filter(isField)
  return [...new Set(names)]
}

// Filled fields become their value; empty ones keep their [brackets].
export function fill(template: string, values: Record<string, string>): string {
  return template.replace(PATTERN, (match, name: string) => {
    const value = (values[name] ?? '').trim()
    return isField(name) && value ? value : match
  })
}

export type Segment = { text: string; field?: string; filled?: boolean }

// For the live preview: plain text and field segments.
export function segments(template: string, values: Record<string, string>): Segment[] {
  const out: Segment[] = []
  let last = 0
  for (const m of template.matchAll(PATTERN)) {
    if (!isField(m[1])) continue
    if (m.index! > last) out.push({ text: template.slice(last, m.index) })
    const value = (values[m[1]] ?? '').trim()
    out.push({ text: value || m[0], field: m[1], filled: Boolean(value) })
    last = m.index! + m[0].length
  }
  if (last < template.length) out.push({ text: template.slice(last) })
  return out
}
